import { useEffect } from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const ProgressBarsSecondarySidebar: React.FC = () => {
  const { relevantProgressBarDesigns, setDisplayProgressBarPreview } =
    useTemplateStudioState();

  useEffect(() => {
    setDisplayProgressBarPreview(true);
    return () => {
      setDisplayProgressBarPreview(false);
    };
  }, []);

  return (
    <>
      {relevantProgressBarDesigns?.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="progressBar.selectedDesignId"
        />
      ))}
    </>
  );
};
